import { SearchIcon, TrashIcon, UploadIcon } from '@heroicons/react/outline'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import useDraft from '../../../redux/draft-drawer/useDraft'
import { Button } from '../../System'
import ROUTES from '../../utils/routes'
import { PreviewImage } from '../../utils/useFileUpload'
import { DraftDrawerErrorBanner } from '../DraftDrawerErrorBanner'
import { DraftDrawerScheduleBanner } from '../DraftDrawerScheduleBanner'
import { StyledDraftDrawerImage } from '.'

type Props = {
  previewImage?: PreviewImage;
  handlePreviewImage: (files?: FileList) => void;
}

const DraftDrawerImage: FC<Props> = ({ previewImage, handlePreviewImage }) => {
  const {
    imageUrl,
    actions: { clearDraftImage }
  } = useDraft()

  const clearImage = () => {
    clearDraftImage()
    handlePreviewImage(undefined)
  }

  return (
    <>
      <DraftDrawerErrorBanner />
      <DraftDrawerScheduleBanner />
      <StyledDraftDrawerImage id="draft-drawer-image">
        {(imageUrl || previewImage) && (
          <>
            <img src={imageUrl || previewImage?.url} alt="" />
            <Button
              type="small"
              theme="ghost"
              className="delete-img-btn"
              onClick={() => clearImage()}
            >
              <TrashIcon />
              Delete Image
            </Button>
          </>
        )}
        {!imageUrl && !previewImage?.url && (
          <div className="draft-drawer-image-placeholder">
            <Button type="small" theme="ghost">
              <input
                type="file"
                name="file"
                multiple={false}
                onChange={(e) => handlePreviewImage(e.target.files || undefined)}
                className="image-input"
                accept=".png, .jpg, .jpeg, .heic"
              />
              <UploadIcon />
              Upload Image
            </Button>
            <div className="vertical-divider" />
            <Link to={ROUTES.gallery.main}>
              <Button type="small" theme="ghost">
                <SearchIcon />
                Browse Gallery
              </Button>
            </Link>
          </div>
        )}
      </StyledDraftDrawerImage>
    </>
  )
}

export default DraftDrawerImage
